// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"ExpenseCardWarningText-module__flexRow--1Qrfy","warningText":"ExpenseCardWarningText-module__warningText--1fTtd","icon":"ExpenseCardWarningText-module__icon--2_uAr"};